import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
    selector: 'op-vehicle',
    templateUrl: './vehicle.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class VehicleComponent {
}